@if(currentNews){
<app-background-local #background ></app-background-local>
<div class="contenu" (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)" >
   <section class="left">
        <div class="tag" >
          <p>{{'LOCAL.TITLE' | translate}}</p>
          <div class="tag-in" [style.background-color]="currentNews.tagColor" [@fadeZoom]="firstAnimationStateOut ? 'out':'in'"  (@fadeZoom.done)="animOutTagDone()">
            <p>{{('LOCAL.TAG.' + currentNews.tag) | uppercase | translate | uppercase}}</p>
          </div>
        </div>
        <h1 class="titleNews scroll-animation"  [@enterUpSlow]="animationStateIn"
          [@leaveDownSlow]="animationStateOut"  (@leaveDownSlow.done)="animOutDone()"
          (@enterUpSlow.done)="animInDone()"> 
              {{currentNews.title| translate}}
        </h1>
        <section class="content main" *ngIf="currentNews && !startingAnimation">
            <div class="qr-code"  [@leaveDownSlow]="animationStateOut" [@enterUpSlow]="animationStateIn">
                &nbsp;
            </div>
            <pre class="info"  [@leaveDownSlow]="animationStateOut" [@fadeInSlow]="animationStateIn">{{currentNews.text | translate}}</pre>
        </section>
        <section class="dotPlaylist">
            <div [class]="{'dot': true, 'active': count === 0}">
            </div>
            <div [class]="{'dot': true, 'hidden': localNews.length < 2, 'active': count === 1}">
            </div>
            <div [class]="{'dot': true,'hidden': localNews.length < 3, 'active': count === 2}">
            </div>
            <div [class]="{'dot': true,'hidden': localNews.length < 4, 'active': count === 3}">
            </div>
            <div [class]="{'dot': true,'hidden': localNews.length < 5, 'active': count === 4}">
            </div>
        </section>
    </section>
 
    <section class="right" *ngIf="!startingAnimation"  [@fadeZoom]="!isTransitionSafetyToSafety && animationStateOut ? 'out':'in'" >
         @if(currentNews.tag !== 'safety'){
        <div class="wrapper" *ngIf="currentNews.video">
            <video
              #videoLocal
              id="videoLocal"
              [src]="currentNews.video"
              class="video"
              preload="metadata"
              muted="true"
              (loadedmetadata)="onVideoMetadataLoaded()"
            ></video>
            <div *ngIf="!videoIsPlaying" class="playpause"></div>
        </div>
        <img *ngIf="currentNews.image && !currentNews.withAnimation" [src]="currentNews.image" alt=""/>
        <app-animation *ngIf="currentNews.withAnimation" [animationName]="currentNews.tag"
           [imageUrl]="currentNews.image">
        </app-animation>
      }
          @else{
        <app-safety-animation [currentNews]="currentNews" [animOut]="animationStateOut"></app-safety-animation>
      }
      </section>
</div>
}